import React from 'react';

// components
import Video from '../components/VideoContainer';
import TextOverlay from '../components/TextOverlay';
import News from '../components/News'
import styles from '../styles/Home.module.css';
import CompanyOverview from '../components/CompanyOverview';
import Feature from '../components/Feature'; // Featureコンポーネントをインポート
import Contact from '../components/Contact'; // Contactコンポーネントをインポート
import Service from '../components/Service'; // Serviceコンポーネントを復元
import WorksCarousel from '../components/WorksCarousel'; // 実績スライドショー追加
import FAQ from '../components/FAQ'; // FAQセクション追加
import WireframeBackground from '../components/WireframeBackground'; // 動的背景追加

function Home() {
    return (
        <>
            <div className={styles.homeContainer}>
                <WireframeBackground />
                <div className={styles.homeWrap}>
                    <div className={styles.topRow}>
                        <TextOverlay />
                        <Video />
                    </div>



                    {/* 実績スライドショー (左から右へ流れる)をトップ画面内に含める */}
                    <div className={styles.carouselWrapper}>
                        <WorksCarousel />
                    </div>
                </div>

                {/* ニュースセクションを追加 */}
                <div className={styles.newsSection}>
                    <News />
                </div>
                {/* 会社概要セクションを追加 */}
                <div className={styles.companyOverview}>
                    <CompanyOverview />
                </div>

                {/* Serviceセクション (Featureの前に追加) */}
                <div className={styles.serviceSection}>
                    <Service />
                </div>
                {/* What is Rigging? セクション */}
                {/* <div className={styles.whatIsRigging}>
                    <WhatIsRigging />
                </div> */}
                {/* Featureセクションを追加 */}
                <div className={styles.featureSection}>
                    <Feature />
                </div>
                {/* FAQセクションを追加 */}
                <div className={styles.faqSection}>
                    <FAQ />
                </div>
                {/* お問い合わせセクション */}
                <div className={styles.contactSection}>
                    <Contact />
                </div>
                {/* Recruit セクション */}
            </div>

        </>
    );
}
export default Home;